module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/meta-2020.jpg?v=f2a909cf";